package pl.decks.personal.pages.ievp.sections.pitch

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Animation
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.cssRem
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout


object PersonalIntroStateChangeAnimations {
    val DisappearAnimation = Keyframes {
        from {
            Modifier
                .width(PitchSectionStylesheet.Vars.foldedSize.value())
                .height(PitchSectionStylesheet.Vars.foldedSize.value())
                .fontSize(11.cssRem)
        }
        to {
            Modifier.width(SiteLayout.Fraction.none).height(SiteLayout.Fraction.none).fontSize(0.cssRem)
        }
    }
    val UnfoldAnimation = Keyframes {
        from {
            Modifier
                .borderRadius(PitchSectionStylesheet.Vars.Internal.PICircleRounding.value())
                .width(SiteLayout.Fraction.none)
                .height(SiteLayout.Fraction.none)
                .fontSize(0.cssRem)
        }
        to {
            Modifier
                .borderRadius(PitchSectionStylesheet.Vars.Internal.PIBoxRounding.value())
                .width(PitchSectionStylesheet.Vars.Internal.PIBoxWidth.value())
                .height(SiteLayout.Fraction.none)
                .fontSize(0.cssRem)
        }
    }
    val ExpandingAnimation = Keyframes {
        from {
            Modifier.maxHeight(SiteLayout.Fraction.none).fontSize(0.cssRem)
        }
        to {
            Modifier.maxHeight(PitchSectionStylesheet.Vars.Internal.PIBoxMaxHeight.value())
                .fontSize(FontTypography.Size.Normal)
        }
    }

    @Composable
    internal fun get(state: PersonalIntroState): Animation.Listable? {
        val timingFunction = when (state) {
            PersonalIntroState.DISAPPEARING -> AnimationTimingFunction.EaseIn
            else -> AnimationTimingFunction.EaseOut
        }
        val frames = when (state) {
            PersonalIntroState.FOLDED -> null
            PersonalIntroState.DISAPPEARING -> DisappearAnimation
            PersonalIntroState.UNFOLDING -> UnfoldAnimation
            PersonalIntroState.UNFOLDED -> ExpandingAnimation
        }
        return frames?.toAnimation(
            duration = PitchSectionStylesheet.Vars.stateChangeDuration.value(),
            timingFunction = timingFunction,
            delay = null,
            direction = AnimationDirection.Normal,
            fillMode = AnimationFillMode.None,
        )
    }
}
